import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ReactComponent as UserIcon } from 'assets/icons/user_button.svg';
import { ReactComponent as BurgerIcon } from 'assets/icons/burger_menu.svg';
import whiteLogoSrc from 'assets/full_leal_logo_white.svg';
import NotePadIcon from 'assets/icons/note.svg';
import noTitleLogoSrc from 'assets/logo_no_title.svg';
import { LoginButton } from 'components/LoginButton/LoginButton';
import AiAssistant, { AI_WIDGET_THEMES } from 'new-ui/Components/AiAssistent';
import { useTranslation } from 'utils/modifiedTranslation';
import { TAB_IDS } from '../constants';
import { MenuItems } from './MenuItems';
import { MobileMenu } from './MobileMenu';
import styles from './patientMainPageHeaderView.module.css';
import menuItemsStyles from './tabsMenuItems.module.css';

export const PatientMainPageHeaderView = ({
  isLogoShown = true,
  onLogoClick,
  tabIds,
  onProfileButtonClick,
  onMobileMenuItemClick,
  isMobileMenuOpen,
  activeTab,
  isAuthenticated,
  isProfileButtonShown = true,
  isUploadButtonShown = true,
  toggleMobileMenu,
  onHelpWithTinaClick,
  userCondition,
  headerRightSlot,
  isBurgerMenuShown = true,
  isLoginButtonShown,
  isProviderMode,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <header className={cx(styles.root, isProviderMode ? styles.providerRoot : styles.nonProviderRoot)}>
        {isLogoShown && (
          <>
            <img
              className={styles.logo}
              src={whiteLogoSrc}
              alt="Leal Health Logo"
              onClick={onLogoClick}
            />
            <img
              className={styles.logoNoTitle}
              src={noTitleLogoSrc}
              alt="Leal Health Logo"
              onClick={onLogoClick}
            />
          </>
        )}
        {!!tabIds.length && (
          <MenuItems
            tabIds={tabIds}
            onMenuItemClick={onMobileMenuItemClick}
            isAuthenticated={isAuthenticated}
            activeItem={activeTab}
            userCondition={userCondition}
            classes={menuItemsStyles}
          />
        )}

        {tabIds.includes(TAB_IDS.SPEAK_WITH_TINA) && activeTab !== TAB_IDS.SPEAK_WITH_TINA && (
          <div
            className={styles.helpButton}
            onClick={onHelpWithTinaClick}
          >
            {t('general.help_with_tina')}
          </div>
        )}

        {(isProfileButtonShown || isUploadButtonShown) && (
          <div className={styles.buttonsWrapper}>
            {isUploadButtonShown && (
              <AiAssistant
                theme={AI_WIDGET_THEMES.DARK}
                customUploadIcon={NotePadIcon}
                customUploadLabel={' '}
              />
            )}
            {isProfileButtonShown && (
              <div
                className={styles.profileButton}
                onClick={onProfileButtonClick}
              >
                <UserIcon />
              </div>
            )}
          </div>
        )}

        {isBurgerMenuShown && (
          <div className={styles.burger} onClick={toggleMobileMenu}>
            <BurgerIcon />
          </div>
        )}

        {headerRightSlot}

        {isLoginButtonShown && <LoginButton color="primary" />}
      </header>
      {isBurgerMenuShown && (
        <MobileMenu
          isOpen={isMobileMenuOpen}
          tabIds={tabIds}
          toggleMobileMenu={toggleMobileMenu}
          onMobileMenuItemClick={onMobileMenuItemClick}
          isAuthenticated={isAuthenticated}
          userCondition={userCondition}
          activeItem={activeTab}
          isUploadButtonShown={isUploadButtonShown}
          isProfileButtonShown={isProfileButtonShown}
          onProfileButtonClick={onProfileButtonClick}
        />
      )}
    </>
  );
};

PatientMainPageHeaderView.propTypes = {
  activeTab: PropTypes.string,
  tabIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isProviderMode: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isMobileMenuOpen: PropTypes.bool.isRequired,
  isLogoShown: PropTypes.bool,
  isProfileButtonShown: PropTypes.bool,
  isUploadButtonShown: PropTypes.bool,
  isLoginButtonShown: PropTypes.bool,
  isBurgerMenuShown: PropTypes.bool,
  onLogoClick: PropTypes.func,
  onHelpWithTinaClick: PropTypes.func,
  toggleMobileMenu: PropTypes.func.isRequired,
  headerRightSlot: PropTypes.node,
  onMobileMenuItemClick: PropTypes.func.isRequired,
  onProfileButtonClick: PropTypes.func.isRequired,
  userCondition: PropTypes.string,
};
